import { render, staticRenderFns } from "./NewsletterSignup.vue?vue&type=template&id=650a065e&"
import script from "./NewsletterSignup.ts?vue&type=script&lang=ts&"
export * from "./NewsletterSignup.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports